<template>
  <page @click="() => batchSetData = ''">
    <module :title="id ? '编辑APP图标/背景模板' : '添加APP图标/背景模板'">
        <c-form ref="form">
            <c-form-item type="hidden" name="id"></c-form-item>
            <c-form title="基础信息">
                <c-form-column>
                    <c-form-item type="input" label="模板名称" name="template_name" required></c-form-item>
                    <c-form-item type="datetime" label="生效时间" start-name="effect_start_time" end-name="effect_end_time" required></c-form-item>
                    <c-form-item type="select" label="UI主题色" name="ui_theme_type" :options="themeType"></c-form-item>
                </c-form-column>
            </c-form>
            <c-form title="头部背景">
                <c-form-item type="image" label="通用" name="head_general_url"
                       file-word="消息、采购单、分类、确认订单等模块背景; 图片尺寸: 750X248px。jpg，png格式" required>
                 </c-form-item>
            </c-form>
            <c-form title="页面背景">
                <c-form-item type="image" label="个人中心" name="page_personal_center_url"
                       file-word="个人中心模块背景; 图片尺寸: 750X420px<br>jpg，png格式" required>
                </c-form-item>
            </c-form>
           <c-form title="底部图标">
               <c-form-column>
                   <c-form-item type="image" label="【默认】首页" name="bottom_index_url" file-word="尺寸: 100X100px 或200X200px png格式" required></c-form-item>
                   <c-form-item type="image" label="【默认】分类" name="bottom_class_url" file-word="尺寸: 100X100px 或200X200px png格式" required></c-form-item>
                   <c-form-item type="image" label="【默认】采购单" name="bottom_purchase_url" file-word="尺寸: 100X100px 或200X200px png格式" required></c-form-item>
                   <c-form-item type="image" label="【默认】我的" name="bottom_my_url" file-word="尺寸: 100X100px 或200X200px png格式" required></c-form-item>
               </c-form-column>
               <c-form-column>
                   <c-form-item type="image" label="【选中】首页" name="bottom_index_check_url" file-word="尺寸: 100X100px 或200X200px png格式" required></c-form-item>
                   <c-form-item type="image" label="【选中】分类" name="bottom_class_check_url" file-word="尺寸: 100X100px 或200X200px png格式" required></c-form-item>
                   <c-form-item type="image" label="【选中】采购单" name="bottom_purchase_check_url" file-word="尺寸: 100X100px 或200X200px png格式" required></c-form-item>
                   <c-form-item type="image" label="【选中】我的" name="bottom_my_check_url" file-word="尺寸: 100X100px 或200X200px png格式" required></c-form-item>
               </c-form-column>
           </c-form>
           <c-form title="底部背景及文字">
               <c-form-column>
                   <c-form-item type="image" label="背景图" name="bottom_background_url"
                   file-word="图片尺寸: 750X172px。jpg，png格式 (注：背景可用高度104px，包括IOS底部68px背景总高度172px)" required></c-form-item>
               </c-form-column>
               <c-form-column>
                    <c-form-item type="input" label="默认文字颜色" name="words" required></c-form-item>
                    <c-form-item type="input" label="选中文字颜色" name="words_check" required></c-form-item>
               </c-form-column>
           </c-form>
        </c-form>

      <template slot="button">
        <c-button size="m" @click="submit(2)">提交保存</c-button>
      </template>
    </module>
  </page>
</template>

<script>
export default {
  name: 'b_app_style_edit',
  data() {
    return {
            themeType: [
                {name: '深色',value: 1},
                {name: '浅色',value: 2}
            ]
    }
  },
  props: {
    id: String
  },
  computed: {

  },

  watch: {
    id() {
        this.getDetail();
    },
  },

  mounted() {
        if (this.id) {
            this.getDetail();
        }
  },
  methods: {
    /**加载详情**/
    getDetail() {
      this.request({
        url:'/app/style/template/detail',
        data: {
          id: this.id
        },
        loading: true,
        success: data => {
          this.$refs.form.set(data);
        }
      });
    },
    /*****提交数据******/
    submit() {
               var submit_obj = this.$refs.form.serialize();
               this.request({
                       url:'/app/style/template/edit',
                       data:submit_obj,
                        success: data => {
                            this.$message({
                                text: '保存成功'
                            });
                            //刷新列表
                            this.$bus.$emit('app_style_list.update', {})
                        }
               });
    }
  }
}
</script>